const isEmptyObject = (o) =>
  o === null || o === undefined || Object.values(o).every((v) => v === undefined || v === '');

const getInfoForUser = (user, userEmployments, hasInfo) => {
  if (user && hasInfo(user)) {
    return { ...user, infoComesFromEmployer: false };
  }
  if (userEmployments && userEmployments[0] && hasInfo(userEmployments[0])) {
    return { ...userEmployments[0], infoComesFromEmployer: true };
  }
  return {};
};

const isFormattable = (value) => value || value === 0;
const formatAsPercent = (value) => (isFormattable(value) ? `${value}%` : '');
const formatAsDollars = (value) => (isFormattable(value) ? `$${value}` : '');

const formatName = ({ givenName, middleName, familyName }) =>
  `${givenName} ${middleName ?? ''} ${familyName}`.replaceAll('  ', ' ');

export { isEmptyObject, getInfoForUser, formatAsPercent, formatAsDollars, formatName };
